function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useWizard } from 'react-use-wizard';
import classNames from 'classnames';
import { AMPLITUDE_EVENTS } from '../../../../constants/analytics';
import { MEMBERSHIP } from '../../../../constants/membership';
import { subscribe } from '../../../../redux/actions';
import text from '../../../../text';
import { amplitudeTrack } from '../../../../utilities';
import Button from '../../../button/Button';
import Icon from '../../../icon/Icon';
import Lottie from '../../../lottie/Lottie';
import { MAP_TYPE } from '../../../../components/mapView/constants';
import { profileConstants } from '../../../../redux/constants';
var FEATURES = [
    {
        icon: '2d-map',
        title: text('highRes2DMap'),
        description: text('startTrialFeature2d')
    },
    {
        icon: 'file',
        title: text('fileManager'),
        description: text('startTrialFeatureFileManager')
    },
    {
        icon: '3D',
        title: text('viewer3D'),
        description: text('startTrialFeature3d')
    }
];
var DATA_FEATURES = [
    {
        icon: 'streetscape',
        title: text('streetscape3D'),
        description: text('startTrialStreetscapeFeature'),
        iconClassName: 'streetscape enabled'
    },
    {
        icon: 'aerial',
        title: text('aerial3D'),
        description: text('startTrialAerialFeature'),
        iconClassName: 'aerial enabled'
    }
];
var ACCEPTED_INTRO_OFFER = AMPLITUDE_EVENTS.ACCEPTED_INTRO_OFFER;
var StartTrialStep = function(param) {
    var onCancel = param.onCancel, isHighResClicked = param.isHighResClicked;
    var nextStep = useWizard().nextStep;
    var dispatch = useDispatch();
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            upsertMembership: state.profileReducer.upsertMembership
        };
    }), currentUser = _useSelector.currentUser, upsertMembership = _useSelector.upsertMembership;
    var handleClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                dispatch(subscribe({
                    user: currentUser,
                    priceId: MEMBERSHIP.MONTHLY.PRICE_ID,
                    isTrial: true
                }));
                if (isHighResClicked) {
                    dispatch({
                        type: profileConstants.UPDATE_MAP_TYPE,
                        payload: MAP_TYPE.HIGH_RES
                    });
                }
                nextStep();
                return [
                    2
                ];
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var trackCloseTrial = function() {
        amplitudeTrack(ACCEPTED_INTRO_OFFER.EVENT, {
            action: ACCEPTED_INTRO_OFFER.CLOSE_TRIAL
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "center-content flex-column",
        onHide: function() {
            return trackCloseTrial();
        },
        close: true,
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Lottie, {
        lottie: "free-gift"
    }), /*#__PURE__*/ React.createElement("h3", null, text('freeTrialPlatform'))), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement("h5", {
        className: "mt-2 mb-3 center-content"
    }, text('measureCollaboratePlatform')), /*#__PURE__*/ React.createElement("ul", {
        className: "p-0"
    }, FEATURES.map(function(item, i) {
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "m-2 center-content"
        }, /*#__PURE__*/ React.createElement(Icon, {
            className: "mr-3 framed outline-primary",
            icon: item.icon
        }), /*#__PURE__*/ React.createElement("h6", null, item.title, ' ', /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-normal"
        }, item.description)));
    })), /*#__PURE__*/ React.createElement("h5", {
        className: "mt-4 mb-3 center-content"
    }, text('getFreeDataDiscount', {
        amount: '49.50'
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "p-0"
    }, DATA_FEATURES.map(function(item, i) {
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "m-2 center-content"
        }, /*#__PURE__*/ React.createElement(Icon, {
            className: classNames('mr-3 framed outline-primary', _define_property({}, item.iconClassName, item.iconClassName)),
            icon: item.icon
        }), /*#__PURE__*/ React.createElement("h6", null, item.title, /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-normal"
        }, item.description)));
    }))), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "d-flex flex-column centered"
    }, /*#__PURE__*/ React.createElement(Button, {
        loading: upsertMembership.isLoading,
        onClick: handleClick,
        autoFocus: true
    }, text('startTrial')), /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        className: "mt-2",
        onClick: function() {
            trackCloseTrial();
            onCancel();
        },
        disabled: upsertMembership.isLoading
    }, text('maybeLater'))));
};
export default StartTrialStep;
